/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class PartyRolePartyDialog extends SiteEntityDialog<PartyRolePartyRow, any> {
        protected getFormKey() { return PartyRolePartyForm.formKey; }
        protected getIdProperty() { return PartyRolePartyRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRolePartyRow.localTextPrefix; }
        protected getNameProperty() { return PartyRolePartyRow.nameProperty; }
        protected getService() { return PartyRolePartyService.baseUrl; }

        protected form = new PartyRolePartyForm(this.idPrefix);

    }
}